import React, { useState, useEffect } from 'react';
import {
  Modal,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Grid,
  Typography,
  ButtonBase,
  IconButton,
  InputAdornment,
  Radio,
  Backdrop,
  CircularProgress,
  Switch,
  Stack,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CompleteButton from '../shared/CompleteButton';
import CancelButton from '../shared/CancelButton';
import api from 'src/services/BaseService';
import { toast } from 'react-toastify';
import Services from 'src/services/Services';
import Iconify from '../iconify/Iconify';
import { useLocalization } from 'src/context/LocalizationContext';

const AddEditPorterModal = ({
  openCreateModal,
  onCreateModal,
  isEdit,
  setIsModalEdit,
  editData,
  pageRefresh,
  malls,
}) => {
  const { language } = useLocalization();
  const parsedUser = JSON.parse(localStorage.getItem('user'));
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isBackdropOpen, setIsBackdropOpen] = useState(false);
  const [getirDialogOpen, setGetirDialogOpen] = useState(false);
  const [getirMessage, setGetirMessage] = useState('');
  const [isResetPassButtonDisabled, setIsResetPassButtonDisabled] =
    useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [mallIDForAPI, setMallIDForAPI] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [getirID, setGetirID] = useState('');
  const [showResultMessage, setShowResultMessage] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [formData, setFormData] = useState({
    isOperator: false,
    isAdmin: false,
    name: '',
    lastname: '',
    phoneNumber: '',
    mall: [],
    muhaberatUnit: [],
    porterCode: '',
    password: '',
    status: false,
    canCancel: false,
    canAddQr: false,
    isMuhaberatPorter: false,
  });

  const handleSwitchChange = (event) => {
    const { name, checked, value } = event.target;

    if (name === 'status') {
      setFormData((prevState) => ({ ...prevState, [name]: checked }));
    } else if (name === 'canCancel') {
      setFormData((prevState) => ({ ...prevState, [name]: checked }));
    } else if (name === 'canAddQr') {
      setFormData((prevState) => ({ ...prevState, [name]: checked }));
    } else if (name === 'isMuhaberatPorter') {
      setFormData((prevState) => ({ ...prevState, [name]: checked }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  useEffect(() => {
    if (isEdit && editData) {
      let isOperator = editData.frontAuth.includes('operations');
      let isAdmin = editData.frontAuth.includes('manager');
      let canCancel = editData.frontAuth.includes('can-cancel');
      let canAddQr = editData.frontAuth.includes('can-add-qr');
      let isMuhaberatPorter = editData.frontAuth.includes('muhaberat-porter');
      let status = editData.status === '1';
      let mallIDs = editData.authLocations.mall || [];
      let allowedPoints = editData.allowedPoints || [];

      let branches = [];
      mallIDs.forEach((mallID) => {
        let mall = malls.find((mall) => mall.id === mallID);
        if (mall) {
          branches = branches.concat(mall.offices);
        }
      });

      setBranchList(branches);

      let selectedBranch = allowedPoints.find(
        (point) => point.isFirstResponsible
      );
      let selectedBranchId = selectedBranch ? selectedBranch.id : '';

      setFormData({
        isOperator,
        isAdmin,
        name: editData.name,
        lastname: editData.lastname,
        phoneNumber: editData.phone,
        mall: mallIDs,
        muhaberatUnit: allowedPoints.map((point) => point.id),
        porterCode: editData.username,
        password: editData.password,
        status,
        canCancel,
        canAddQr,
        isMuhaberatPorter,
      });
      const selectedBranchObj = branches.find(
        (branch) => branch.id === selectedBranchId
      );
      setSelectedBranchId(selectedBranchId);
      setMallIDForAPI(selectedBranchObj ? selectedBranchObj.mallID || '' : '');
    }
    setIsLoaded(true);
  }, [isEdit, editData, malls]);

  const handleGetirRegister = () => {
    setIsBackdropOpen(true);
    api
      .post('flow/getir-register', {
        userID: editData.id,
      })
      .then((response) => {
        if (response.data) {
          if (response.data.status === true) {
            setGetirID(response.data.result.getirID);
            setGetirMessage("Getir'e yekilendirme başarıyla tamamlandı!");
            setIsBackdropOpen(false);
            handleGetirDialogOpen();
          } else if (response.data.status === false) {
            setGetirMessage("Getir'e yetkilendirirken bir hata oluştu!");
            setIsBackdropOpen(false);
            handleGetirDialogOpen();
          }
          editData.getirID = response.data.result.getirID;
          pageRefresh();
        } else {
          // toast.error(response.data.message);
        }
      })
      .catch((error) => {});
  };

  const handleCopyGetirCode = () => {
    navigator.clipboard
      .writeText(editData.getirID)
      .then(() => {})
      .catch((err) => {
        console.error('Şifre kopyalanırken bir hata oluştu:', err);
      });
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleGetirDialogOpen = () => {
    setGetirDialogOpen(true);
  };

  const handleGetirDialogClose = () => {
    setGetirDialogOpen(false);
  };

  const handleResetPassword = () => {
    setIsBackdropOpen(true);
    setIsResetPassButtonDisabled(true);
    api
      .post('flow/user-forced-reset-password', {
        userID: editData.id,
      })
      .then((response) => {
        if (response.data) {
          setFormData({
            ...formData,
            password: response.data.result,
          });
          setIsResetPassButtonDisabled(false);
          setIsBackdropOpen(false);
          handleDialogOpen();
          pageRefresh();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const handleCopyPassword = () => {
    navigator.clipboard
      .writeText(formData.password)
      .then(() => {
        // // console.log('Şifre kopyalandı:', formData.password);
      })
      .catch((err) => {
        console.error('Şifre kopyalanırken bir hata oluştu:', err);
      });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const handleTextFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ... (Diğer tüm mevcut fonksiyonlar burada değişmeden kalıyor)
  const handleMallChange = async (e) => {
    const { name, value } = e.target;
    const previousSelection = formData[name] || [];
    const mergedSelection = [
      ...previousSelection,
      ...value.filter((item) => !previousSelection.includes(item)),
    ];

    setFormData({
      ...formData,
      [name]: mergedSelection,
    });

    const selectedMalls = malls.filter((mall) =>
      mergedSelection.includes(mall.id)
    );
    let updatedBranchList = [];
    for (let i = 0; i < selectedMalls.length; i++) {
      const mall = selectedMalls[i];
      const offices = mall.offices;
      for (let j = 0; j < offices.length; j++) {
        updatedBranchList = updatedBranchList.concat(offices[j]);
      }
    }
    setBranchList(updatedBranchList);
  };

  const handleMuhaberatUnitChange = (e) => {
    const { name, value } = e.target;
    const previousSelection = formData[name] || [];
    const mergedSelection = [
      ...previousSelection,
      ...value.filter((item) => !previousSelection.includes(item)),
    ];

    setFormData({
      ...formData,
      [name]: mergedSelection,
    });
  };

  const allFieldsAreValid = () => {
    const errorTextArr = [];
    const {
      isOperator,
      isAdmin,
      name,
      lastname,
      phoneNumber,
      mall,
      muhaberatUnit,
      password,
    } = formData;

    const passwordHasSpace = Boolean(password) && password.includes(' ');
    const passwordOk = isEdit
      ? !passwordHasSpace
      : Boolean(password) && !passwordHasSpace;

    const isFormFilled =
      (isOperator || isAdmin) &&
      name &&
      lastname &&
      phoneNumber.length === 10 &&
      mall.length > 0 &&
      muhaberatUnit.length > 0 &&
      selectedBranchId &&
      passwordOk;

    const atLeastOneBranchSelectedPerMall = mall.every((mallId) => {
      const branchesForMall = branchList.filter(
        (branch) => branch.mallID === mallId
      );
      return branchesForMall.some((branch) =>
        muhaberatUnit.includes(branch.id)
      );
    });

    if (isFormFilled && atLeastOneBranchSelectedPerMall) {
      return false;
    } else {
      if (isOperator === false && isAdmin === false) {
        errorTextArr.push('En az bir yetki seçiniz');
      }
      if (!name) {
        errorTextArr.push('Porter adı giriniz');
      }
      if (!lastname) {
        errorTextArr.push('Porter soyadı giriniz');
      }
      if (phoneNumber.length < 10) {
        errorTextArr.push('Telefon numarası giriniz');
      }
      if (mall.length === 0) {
        errorTextArr.push('En az 1 tane AVM seçiniz');
      }
      if (muhaberatUnit.length === 0) {
        errorTextArr.push('En az 1 tane birim seçiniz');
      }
      if (!selectedBranchId) {
        errorTextArr.push('Ana yetki birimi seçiniz');
      }
      if (!isEdit && !password) {
        errorTextArr.push('Şifre giriniz');
      }
      if (passwordHasSpace) {
        errorTextArr.push('Şifreden boşluk karakterini siliniz');
      }
      if (atLeastOneBranchSelectedPerMall === false) {
        errorTextArr.push('Seçilen her AVM için en az 1 tane birim seçiniz');
      }

      let errMsg = '';
      for (let i = 0; i < errorTextArr.length; i++) {
        if (i === errorTextArr.length - 1) {
          errMsg += errorTextArr[i];
        } else {
          errMsg += errorTextArr[i] + ', ';
        }
      }

      return true;
    }
  };

  const userSetStatus = () => {
    if (formData?.status === false) {
      Services.UserSetPassive(parsedUser.token, editData.id)
        .then((res) => {
          if (res.data.status) {
            setResultMessage('Porter başarıyla güncellendi!');
            setShowResultMessage(true);
            setIsBackdropOpen(true);
          } else {
            setResultMessage('Porter güncellenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
            setIsBackdropOpen(true);
          }
        })
        .catch((err) => {});
    } else {
      Services.UserSetActive(parsedUser.token, editData.id)
        .then((res) => {
          if (res.data.status) {
            setResultMessage('Porter başarıyla güncellendi!');
            setShowResultMessage(true);
            setIsBackdropOpen(true);
          } else {
            setResultMessage('Porter güncellenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
            setIsBackdropOpen(true);
          }
        })
        .catch((err) => {});
    }
  };

  const handleUpdate = () => {
    setIsBackdropOpen(true);
    let checkIsAdminator = false;
    let frontAuthArr = [];

    if (formData.isAdmin) {
      checkIsAdminator = true;
      frontAuthArr.push('manager');
    }

    if (formData.isOperator) {
      frontAuthArr.push('operations');
    }

    if (formData.canCancel) {
      frontAuthArr.push('can-cancel');
    }

    if (formData.canAddQr) {
      frontAuthArr.push('can-add-qr');
    }

    if (formData.isMuhaberatPorter) {
      frontAuthArr.push('muhaberat-porter');
    }

    const muhaberatUnitObjects = formData.muhaberatUnit.map((unitId) => {
      return {
        id: unitId,
        isFirstResponsible: unitId === selectedBranchId,
      };
    });

    const mallObject = { mall: formData.mall };

    const payload = {
      userID: editData.id,
      name: formData.name,
      lastname: formData.lastname,
      phone: formData.phoneNumber,
      isAdministrator: checkIsAdminator,
      mallID: mallIDForAPI,
      type: 'porter',
      allowedPoints: muhaberatUnitObjects,
      frontAuth: frontAuthArr,
      accountCategory: 'mall-logistics',
      status: '0',
      authLocations: mallObject,
    };

    if (formData.password && formData.password.trim().length > 0) {
      payload.password = formData.password;
    }

    api
      .post('/users/update-profile', payload)
      .then((response) => {
        if (response.data) {
          userSetStatus();
        } else {
          setResultMessage('Porter güncellenirken bir sorunla karşılaşıldı!');
          setShowResultMessage(true);
          setIsBackdropOpen(true);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const handleCloseMessage = () => {
    if (isEdit) {
      setIsModalEdit(false);
    }
    setShowResultMessage(false);
    onCreateModal();
    pageRefresh();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsBackdropOpen(true);
    let checkIsAdminator = false;
    let frontAuthArr = [];

    if (formData.isAdmin) {
      checkIsAdminator = true;
      frontAuthArr.push('manager');
    }

    if (formData.isOperator) {
      frontAuthArr.push('operations');
    }

    if (formData.canCancel) {
      frontAuthArr.push('can-cancel');
    }

    if (formData.canAddQr) {
      frontAuthArr.push('can-add-qr');
    }

    if (formData.isMuhaberatPorter) {
      frontAuthArr.push('muhaberat-porter');
    }

    const muhaberatUnitObjects = formData.muhaberatUnit.map((unitId) => {
      return {
        id: unitId,
        isFirstResponsible: unitId === selectedBranchId,
      };
    });
    const mallObject = { mall: formData.mall };
    api
      .post('/flow/users-create-employee', {
        name: formData.name,
        lastname: formData.lastname,
        phone: formData.phoneNumber,
        username: 'default',
        password: formData.password,
        isAdministrator: checkIsAdminator,
        mallID: mallIDForAPI,
        type: 'porter',
        allowedPoints: muhaberatUnitObjects,
        frontAuth: frontAuthArr,
        accountCategory: 'mall-logistics',
        authLocations: mallObject,
      })
      .then((response) => {
        if (response.data && response.data.status === false) {
          setResultMessage('Porter eklenirken bir sorunla karşılaşıldı!');
          setShowResultMessage(true);
          setIsBackdropOpen(true);
        } else if (response.data) {
          setResultMessage('Porter başarıyla eklendi!');
          setShowResultMessage(true);
          setIsBackdropOpen(true);
        } else {
          setResultMessage('Porter eklenirken bir sorunla karşılaşıldı!');
          setShowResultMessage(true);
          setIsBackdropOpen(true);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });

    setIsModalEdit(false);
  };

  const getMallTitleByID = (mallId) => {
    const mall = malls.find((mall) => mall.id === mallId);
    return mall ? mall.title : null;
  };

  const getBranchTitleByID = (branchId) => {
    const branch = branchList.find((branch) => branch.id === branchId);
    return branch ? branch.title : null;
  };

  const handleRemoveMall = (mallId) => {
    const updatedMalls = formData.mall.filter((id) => id !== mallId);

    const updatedMuhaberatUnit = formData.muhaberatUnit.filter((branchId) => {
      const branch = branchList.find((branch) => branch.id === branchId);
      return branch && branch.mallID !== mallId;
    });

    if (updatedMuhaberatUnit.includes(selectedBranchId) === false) {
      setSelectedBranchId('');
    }

    setFormData({
      ...formData,
      mall: updatedMalls,
      muhaberatUnit: updatedMuhaberatUnit,
    });

    const updatedBranchList = branchList.filter((branch) =>
      updatedMalls.includes(branch.mallID)
    );

    setBranchList(updatedBranchList);
  };

  const handleRemoveBranch = (branchId) => {
    const updatedBranches = formData.muhaberatUnit.filter(
      (id) => id !== branchId
    );

    if (branchId === selectedBranchId) {
      setSelectedBranchId('');
    }
    setFormData({
      ...formData,
      muhaberatUnit: updatedBranches,
    });
  };

  const handleSelectBranch = (branchId) => {
    setSelectedBranchId(branchId);
    const selectedBranchMall = branchList.find(
      (object) => object.id === branchId
    );
    setMallIDForAPI(selectedBranchMall.mallID);
  };

  const handleCloseModal = () => {
    onCreateModal(false);
    setIsModalEdit(false);
  };

  if (!isLoaded) {
    return null;
  } else {
    return (
      <Modal open={openCreateModal}>
        <>
          <Backdrop sx={{ color: '#fff', zIndex: 1 }} open={isBackdropOpen}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              width: '90%',
              maxWidth: 930,
              maxHeight: '100%',
              borderRadius: 2,
              overflow: 'auto',
              paddingBottom: 8,
              paddingTop: 8,
            }}
          >
            <Dialog
              open={showResultMessage}
              onClose={handleCloseMessage}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {isEdit === true ? (
                <DialogTitle id="alert-dialog-title">
                  {language.components.AddEditPorterModal.porter_edit}
                </DialogTitle>
              ) : (
                <DialogTitle id="alert-dialog-title">
                  {language.components.AddEditPorterModal.porter_add}
                </DialogTitle>
              )}
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {resultMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseMessage}
                  data-testid="porter-form-success-dialog-okay-btn"
                >
                  {language.commons.okay}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={getirDialogOpen}
              onClose={handleGetirDialogClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {language.components.AddEditPorterModal.getir_auth}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {getirMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleGetirDialogClose}
                  data-testid="porter-form-getir-dialog-okay-btn"
                >
                  {language.commons.okay}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={dialogOpen}
              onClose={handleDialogClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{'Yeni Şifre'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {language.components.AddEditPorterModal.password_warning}
                </DialogContentText>
                <br />
                <DialogContentText
                  disabled
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 1,
                  }}
                  id="alert-dialog-description"
                >
                  <TextField
                    disabled
                    fullWidth
                    type="text"
                    label={language.commons.labels.password}
                    name="password"
                    value={formData.password}
                    onChange={handleTextFieldChange}
                    margin="normal"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button onClick={handleCopyPassword}>
                            <ContentCopyIcon color="action" />
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                  />
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDialogClose}>
                  {language.commons.close}
                </Button>
              </DialogActions>
            </Dialog>
            <form onSubmit={handleSubmit}>
              {!isEdit && (
                <div
                  style={{
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    marginBottom: '15px',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontSize: '24px',
                      fontWeight: '600',
                      color: '#000000',
                    }}
                    gutterBottom
                  >
                    {language.components.AddEditPorterModal.porter_form}
                  </Typography>
                </div>
              )}

              {isEdit === false ? (
                <>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#374151',
                    }}
                    gutterBottom
                  >
                    {language.components.AddEditPorterModal.porter_only_add}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#6B7280',
                    }}
                    gutterBottom
                  >
                    {language.components.AddEditPorterModal.porter_warning}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#374151',
                    }}
                    gutterBottom
                  >
                    {language.components.AddEditPorterModal.add_porter_info}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: '400',
                      color: '#6B7280',
                    }}
                    gutterBottom
                  >
                    {language.components.AddEditPorterModal.user_info_message}
                  </Typography>
                </>
              )}
              {isEdit && (
                <div
                  style={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: '#EAECF0',
                    marginTop: '20px',
                    marginBottom: '15px',
                  }}
                />
              )}

              {isEdit && (
                <Stack
                  width="100%"
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <div
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: '600',
                        fontSize: '14px',
                        color: '#1570EF',
                        fontFamily: 'Inter',
                        marginRight: '5px',
                      }}
                    >
                      {editData.name} {editData.lastname}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        fontFamily: 'Inter',
                        marginRight: '5px',
                      }}
                    >
                      {language.components.AddEditPorterModal.use_countinue}
                    </Typography>
                  </div>
                  <div
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: '500',
                        fontSize: '14px',
                        color: '#6B7280',
                        fontFamily: 'Inter',
                        marginRight: '5px',
                      }}
                    >
                      {language.commons.labels.user_status}:
                    </Typography>
                    {formData.status ? (
                      <Typography
                        sx={{
                          fontWeight: '500',
                          fontSize: '14px',
                          color: '#079455',
                          fontFamily: 'Inter',
                        }}
                      >
                        {language.commons.labels.active}
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          fontWeight: '500',
                          fontSize: '14px',
                          color: '#D92D20',
                          fontFamily: 'Inter',
                        }}
                      >
                        {language.commons.labels.passive}
                      </Typography>
                    )}

                    <Switch
                      checked={formData.status}
                      onChange={handleSwitchChange}
                      name="status"
                      color="primary"
                      inputProps={{
                        'aria-label': 'primary checkbox',
                        'data-testid': 'porter-form-status-switch',
                      }}
                    />
                  </div>
                </Stack>
              )}
              <div
                style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#EAECF0',
                  marginTop: '20px',
                }}
              />
              <Grid item xs={12} container alignItems="center" spacing={2}>
                <Grid xs={4} item>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      color: '#667085',
                      fontWeight: 600,
                      fontSize: '14px',
                    }}
                  >
                    {language.components.AddEditPorterModal.use_info}
                  </Typography>
                </Grid>
                <Grid xs={4} item>
                  <TextField
                    fullWidth
                    label={language.commons.labels.name + '*'}
                    name="name"
                    value={formData.name}
                    onChange={handleTextFieldChange}
                    margin="normal"
                    inputProps={{ 'data-testid': 'porter-form-name-input' }}
                  />
                </Grid>
                <Grid xs={4} item>
                  <TextField
                    fullWidth
                    label={language.commons.labels.lastname + '*'}
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleTextFieldChange}
                    margin="normal"
                    inputProps={{ 'data-testid': 'porter-form-lastname-input' }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} container alignItems="center" spacing={2}>
                <Grid xs={4} item></Grid>
                <Grid xs={8} item>
                  {isEdit === false ? (
                    <>
                      <TextField
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        label={language.commons.labels.password + '*'}
                        name="password"
                        value={formData.password}
                        onChange={handleTextFieldChange}
                        margin="normal"
                        inputProps={{
                          'data-testid': 'porter-form-password-input',
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                                data-testid="porter-form-password-toggle"
                              >
                                <Iconify
                                  icon={
                                    showPassword
                                      ? 'eva:eye-fill'
                                      : 'eva:eye-off-fill'
                                  }
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {formData?.password?.includes(' ') ? (
                        <Alert severity="error">
                          {language.components.AddEditPorterModal.password_info}
                        </Alert>
                      ) : null}
                    </>
                  ) : (
                    <CompleteButton
                      label={'Şifreyi Sıfırla'}
                      disabled={isResetPassButtonDisabled}
                      onClick={() => handleResetPassword()}
                      sx={{
                        mt: 2,
                        ml: 'auto',
                        float: 'left',
                        width: '210px  ',
                      }}
                    />
                  )}
                </Grid>
              </Grid>

              <div
                style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#EAECF0',
                  marginTop: '20px',
                  marginBottom: '15px',
                }}
              />

              <Grid item xs={12} container alignItems="center" spacing={2}>
                <Grid xs={4} item>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      color: '#667085',
                      fontWeight: 600,
                      fontSize: '14px',
                    }}
                  >
                    {language.commons.user_contact}
                  </Typography>
                </Grid>
                <Grid xs={8} item>
                  <TextField
                    fullWidth
                    type="number"
                    label="5XXXXXXXXX*"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleTextFieldChange}
                    margin="normal"
                    inputProps={{ 'data-testid': 'porter-form-phone-input' }}
                    onInput={(e) => {
                      let inputValue = e.target.value;
                      if (inputValue < 0) {
                        inputValue = '0';
                      }
                      if (inputValue.startsWith('0')) {
                        inputValue = inputValue.slice(1);
                      }
                      if (inputValue.length > 10) {
                        inputValue = inputValue.slice(0, 10);
                      }
                      if (inputValue !== e.target.value) {
                        e.target.value = inputValue;
                        setFormData({
                          ...formData,
                          phoneNumber: inputValue,
                        });
                      }
                    }}
                  />
                </Grid>
              </Grid>

              <div
                style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#EAECF0',
                  marginTop: '20px',
                  marginBottom: '15px',
                }}
              />

              <Grid item xs={12} container alignItems="center" spacing={2}>
                <Grid xs={4} item>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      color: '#667085',
                      fontWeight: 600,
                      fontSize: '14px',
                    }}
                  >
                    {language.commons.user_location}
                  </Typography>
                </Grid>
                <Grid xs={4} item>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>{language.commons.labels.mall}*</InputLabel>
                    <Select
                      label={language.commons.labels.mall + '*'}
                      value={formData.mall}
                      onChange={handleMallChange}
                      name="mall"
                      multiple
                      disabled={malls?.length === 0}
                      inputProps={{ 'data-testid': 'porter-form-mall-select' }}
                    >
                      {malls?.map((mall, index) => (
                        <MenuItem key={index} value={mall.id}>
                          {mall.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={4} item>
                  <FormControl fullWidth margin="normal">
                    {formData.mall.length === 0 ? (
                      <InputLabel>
                        {language.commons.labels.mall_choose}
                      </InputLabel>
                    ) : (
                      <InputLabel>
                        {language.commons.labels.mall_department}*
                      </InputLabel>
                    )}
                    <Select
                      label={language.commons.labels.mall_department + '*'}
                      value={formData.muhaberatUnit}
                      onChange={handleMuhaberatUnitChange}
                      name="muhaberatUnit"
                      multiple
                      disabled={branchList.length === 0}
                      inputProps={{
                        'data-testid': 'porter-form-department-select',
                      }}
                    >
                      {branchList.map((branch, index) => (
                        <MenuItem
                          key={index}
                          value={branch.id}
                          data-testid={`porter-form-department-option-${branch.id}`}
                        >
                          {branch.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              {formData.mall.length > 0 && (
                <>
                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#EAECF0',
                      marginTop: '20px',
                      marginBottom: '20px',
                    }}
                  />
                  <Grid item xs={12} container alignItems="center" spacing={2}>
                    <Grid xs={4} item>
                      <Typography
                        sx={{
                          fontFamily: 'Inter',
                          color: '#667085',
                          fontWeight: 600,
                          fontSize: '14px',
                        }}
                      >
                        {language.commons.labels.malls}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} container alignItems="center" spacing={2}>
                      {formData.mall.map((mallId, index) => (
                        <Grid item key={index} justifyContent="space-between">
                          <Chip
                            label={getMallTitleByID(mallId)}
                            variant="outlined"
                            sx={{ borderRadius: 0 }}
                            onDelete={() => handleRemoveMall(mallId)}
                            data-testid={`porter-form-mall-chip-${mallId}`}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </>
              )}

              {formData.muhaberatUnit.length > 0 && (
                <>
                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#EAECF0',
                      marginTop: '20px',
                      marginBottom: '15px',
                    }}
                  />

                  <Grid
                    item
                    xs={12}
                    container
                    alignItems="center"
                    spacing={2}
                    sx={{ marginTop: '15px' }}
                  >
                    <Grid xs={4} item>
                      <Typography
                        sx={{
                          fontFamily: 'Inter',
                          color: '#667085',
                          fontWeight: 600,
                          fontSize: '14px',
                        }}
                      >
                        {language.commons.labels.sections}
                      </Typography>
                    </Grid>
                    <Grid item xs={8} container alignItems="center" spacing={2}>
                      {formData.muhaberatUnit.map((branchId, index) => {
                        const branchTitle = getBranchTitleByID(branchId);
                        return branchTitle ? (
                          <Grid
                            item
                            xs={6}
                            key={index}
                            justifyContent="space-between"
                            sx={{ marginTop: -2 }}
                          >
                            <FormControlLabel
                              control={
                                <Radio
                                  checked={selectedBranchId === branchId}
                                  onChange={() => handleSelectBranch(branchId)}
                                  inputProps={{
                                    'data-testid': `porter-form-branch-radio-${branchId}`,
                                  }}
                                />
                              }
                            />
                            <Chip
                              label={branchTitle}
                              variant="outlined"
                              sx={{ borderRadius: 0, maxWidth: '200px' }}
                              onDelete={() => handleRemoveBranch(branchId)}
                              data-testid={`porter-form-branch-chip-${branchId}`}
                            />
                          </Grid>
                        ) : null;
                      })}
                    </Grid>
                  </Grid>
                </>
              )}

              <div
                style={{
                  width: '100%',
                  height: '1px',
                  backgroundColor: '#EAECF0',
                  marginTop: '20px',
                  marginBottom: '15px',
                }}
              />

              <Grid item xs={12} container alignItems="center" spacing={2}>
                <Grid xs={4} item>
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      color: '#667085',
                      fontWeight: 600,
                      fontSize: '14px',
                    }}
                  >
                    {language.commons.labels.user_auth}
                  </Typography>
                </Grid>
                <Grid xs={4} item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.isOperator}
                        onChange={handleCheckboxChange}
                        name="isOperator"
                        inputProps={{
                          'data-testid': 'porter-form-operator-checkbox',
                        }}
                      />
                    }
                    label={
                      <ButtonBase
                        onClick={() =>
                          setFormData({
                            ...formData,
                            isOperator: !formData.isOperator,
                          })
                        }
                        sx={{
                          borderRadius: 0,
                          cursor: 'pointer',
                          backgroundColor: 'transparent',
                        }}
                        data-testid="porter-form-operator-label"
                      >
                        <Typography>
                          {language.commons.labels.operation}
                        </Typography>
                      </ButtonBase>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.isAdmin}
                        onChange={handleCheckboxChange}
                        name="isAdmin"
                        inputProps={{
                          'data-testid': 'porter-form-admin-checkbox',
                        }}
                      />
                    }
                    label={
                      <ButtonBase
                        onClick={() =>
                          setFormData({
                            ...formData,
                            isAdmin: !formData.isAdmin,
                          })
                        }
                        sx={{
                          borderRadius: 0,
                          cursor: 'pointer',
                          backgroundColor: 'transparent',
                        }}
                        data-testid="porter-form-admin-label"
                      >
                        <Typography>
                          {language.commons.labels.manager}
                        </Typography>
                      </ButtonBase>
                    }
                  />
                </Grid>

                {(parsedUser.type === 'highadmin' ||
                  parsedUser.frontAuth.includes('regional-manager')) && (
                  <Grid
                    xs={12}
                    item
                    sx={{
                      flexDirection: 'row',
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: 2,
                      mt: 1,
                    }}
                  >
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <Typography>
                        {language.commons.labels.cancel_auth}:
                      </Typography>
                      <Switch
                        checked={formData.canCancel}
                        onChange={handleSwitchChange}
                        name="canCancel"
                        color="primary"
                        inputProps={{
                          'aria-label': 'cancel auth switch',
                          'data-testid': 'porter-form-cancel-auth-switch',
                        }}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <Typography>QR Kod Tanımlama:</Typography>
                      <Switch
                        checked={formData.canAddQr}
                        onChange={handleSwitchChange}
                        name="canAddQr"
                        color="primary"
                        inputProps={{
                          'aria-label': 'qr add auth switch',
                          'data-testid': 'porter-form-qr-auth-switch',
                        }}
                      />
                    </div>

                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <Typography>Muhaberat Porter:</Typography>
                      <Switch
                        checked={formData.isMuhaberatPorter}
                        onChange={handleSwitchChange}
                        name="isMuhaberatPorter"
                        color="primary"
                        inputProps={{
                          'aria-label': 'muhaberat porter switch',
                          'data-testid': 'porter-form-muhaberat-porter-switch',
                        }}
                      />
                    </div>
                  </Grid>
                )}
              </Grid>

              {isEdit && (
                <>
                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#EAECF0',
                      marginTop: '20px',
                      marginBottom: '15px',
                    }}
                  />

                  <Grid item xs={12} container alignItems="center" spacing={2}>
                    <Grid xs={4} item>
                      <Typography
                        sx={{
                          fontFamily: 'Inter',
                          color: '#667085',
                          fontWeight: 600,
                          fontSize: '14px',
                        }}
                      >
                        {
                          language.components.AddEditPorterModal
                            .porter_informations
                        }
                      </Typography>
                    </Grid>
                    <Grid xs={6} item>
                      <TextField
                        fullWidth
                        label={
                          language.components.AddEditPorterModal.porter_code +
                          '*'
                        }
                        name="porterCode"
                        value={formData.porterCode}
                        margin="normal"
                        disabled
                        inputProps={{
                          'data-testid': 'porter-form-porter-code-input',
                        }}
                      />
                    </Grid>
                  </Grid>

                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#EAECF0',
                      marginTop: '20px',
                      marginBottom: '15px',
                    }}
                  />

                  <Grid item xs={12} container alignItems="center" spacing={2}>
                    <Grid xs={4} item>
                      <Typography
                        sx={{
                          fontFamily: 'Inter',
                          color: '#667085',
                          fontWeight: 600,
                          fontSize: '14px',
                        }}
                      >
                        {
                          language.components.AddEditPorterModal
                            .getir_code_regis
                        }
                      </Typography>
                    </Grid>
                    <Grid xs={6} item>
                      {editData.getirID !== null && editData.getirID !== '' ? (
                        <TextField
                          fullWidth
                          label={
                            language.components.AddEditPorterModal.getir_code
                          }
                          name="getirCode"
                          value={editData.getirID}
                          margin="normal"
                          disabled
                          inputProps={{
                            'data-testid': 'porter-form-getir-code-input',
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Button
                                  onClick={handleCopyGetirCode}
                                  data-testid="porter-form-copy-getir-code-btn"
                                >
                                  <ContentCopyIcon color="action" />
                                </Button>
                              </InputAdornment>
                            ),
                          }}
                        />
                      ) : (
                        <Button
                          onClick={() => handleGetirRegister()}
                          style={{
                            color: '#FBD30C',
                            backgroundColor: '#5C3CBB',
                            width: '250px',
                            height: '46px',
                            borderRadius: '5px',
                          }}
                          data-testid="porter-form-save-to-getir-btn"
                        >
                          {language.components.AddEditPorterModal.save_to_getir}
                        </Button>
                      )}
                    </Grid>
                  </Grid>

                  <div
                    style={{
                      width: '100%',
                      height: '1px',
                      backgroundColor: '#EAECF0',
                      marginTop: '20px',
                      marginBottom: '15px',
                    }}
                  />
                </>
              )}
              <div
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  marginTop: '25px',
                }}
              >
                <CancelButton
                  onClick={() => handleCloseModal()}
                  label={language.commons.cancel}
                  sx={{ marginRight: '24px' }}
                  data-testid="porter-form-cancel-btn"
                />

                {isEdit === true ? (
                  <CompleteButton
                    label={language.commons.update}
                    disabled={allFieldsAreValid()}
                    onClick={() => handleUpdate()}
                    sx={{ width: '250px' }}
                    data-testid="porter-form-update-btn"
                  />
                ) : (
                  <CompleteButton
                    label={language.commons.add_user}
                    disabled={allFieldsAreValid()}
                    btnType={'save'}
                    type="submit"
                    sx={{ width: '250px' }}
                    data-testid="porter-form-add-user-btn"
                  />
                )}
              </div>
            </form>
          </Box>
        </>
      </Modal>
    );
  }
};

export default AddEditPorterModal;
